import { render, staticRenderFns } from "./SAMO.vue?vue&type=template&id=5d71b33a&scoped=true&"
import script from "./SAMO.vue?vue&type=script&lang=js&"
export * from "./SAMO.vue?vue&type=script&lang=js&"
import style0 from "./SAMO.vue?vue&type=style&index=0&id=5d71b33a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71b33a",
  null
  
)

export default component.exports